import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { PageHeader, TabBofuV2 } from "@components/ui_v2";
import { TabBofuV2Id } from "@components/TabBofu/TabBofuV2";
import { BOFU_TAB_ORDER } from "@components/TabBofu/functions";
import { RootState } from "@store/store";
import { TabEmpresaPFAE } from "@pages/producto/credito_simple/expediente/pm/TabEmpresaPFAE";
import { TabGarantia } from "@pages/producto/credito_simple/expediente/pm/TabGarantia";
import { TabPersonas } from "@pages/producto/credito_simple/expediente/pm/TabPersonas";

type TabBofuV2IdPFAE = Exclude<TabBofuV2Id, "dictamen">;

const HEADERS: Record<TabBofuV2IdPFAE, { eyebrow: string; title: string; subtitle?: string }> = {
  empresa: {
    eyebrow: "Expediente · Empresa/PFAE",
    title: "Documentos de la empresa/PFAE",
    subtitle:
      "Sube los documentos de tu empresa y completa la información de solicitud, información transaccional y declaraciones regulatorias.",
  },
  garantia: {
    eyebrow: "Expediente · Garantía",
    title: "Garantía",
    subtitle: "Registra los bienes o documentos que respaldarán el crédito, según los requerimientos del expediente.",
  },
  personas: {
    eyebrow: "Expediente · Personas relacionadas",
    title: "Personas relacionadas",
    subtitle:
      "Completa la información pendiente de las personas que participan en el expediente, según los roles asignados.",
  },
};

export const ExpedientePFAE = () => {
  const [searchParams] = useSearchParams();
  const expediente = useSelector((state: RootState) => state.expediente);
  const tabParam = searchParams.get("tab") as TabBofuV2Id | null;

  const firstActiveTab: TabBofuV2IdPFAE = expediente.tabsReady
    ? ((BOFU_TAB_ORDER.find(({ queryParam }) => queryParam !== "dictamen" && expediente[queryParam].is_active)
        ?.queryParam ?? "empresa") as TabBofuV2IdPFAE)
    : "empresa";

  const activeTab: TabBofuV2IdPFAE =
    tabParam && tabParam !== "dictamen" && BOFU_TAB_ORDER.some(({ queryParam }) => queryParam === tabParam)
      ? (tabParam as TabBofuV2IdPFAE)
      : firstActiveTab;
  const header = HEADERS[activeTab];

  return (
    <Box>
      <PageHeader eyebrow={header.eyebrow} title={header.title} subtitle={header.subtitle} />

      {/* TabBofuV2 debe quedar siempre montado para no interrumpir la carga del store */}
      <TabBofuV2 active={activeTab} />

      {activeTab === "empresa" && <TabEmpresaPFAE />}
      {activeTab === "garantia" && <TabGarantia />}
      {activeTab === "personas" && <TabPersonas />}
    </Box>
  );
};
